function clearAuthData() {
    localStorage.removeItem('token')
    localStorage.removeItem('user_info')
    localStorage.removeItem('remembered_username')
}
export {
    clearAuthData
}
